import React, { useEffect } from 'react';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { Hub } from 'aws-amplify/utils';
import { get } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';
import { useTheme, View, Image, Text, CheckboxField} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../Components/Logo/Logo with Tagline.png';

const components = {
  Header() {
    return (
      <View textAlign="center">
        <Image
          alt="Flagpole logo"
          src={Logo}
        />
      </View>
    );
  },
  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]}>
          &copy; All Rights Reserved
        </Text>
      </View>
    );
  },
  SignUp: {
    FormFields() {
      const { validationErrors } = useAuthenticator();
      return (
        <>
          {/* Re-use default `Authenticator.SignUp.FormFields` */}
          <Authenticator.SignUp.FormFields />

          {/* Append & require Terms and Conditions field to sign up  */}
            <CheckboxField
              errorMessage={validationErrors.acknowledgement}
              hasError={!!validationErrors.acknowledgement}
              name="acknowledgement"
              value="yes"
              label="I agree with the Terms and Conditions"
            />
            <label htmlFor="acknowledgement">
              <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
            </label>
          </>
      );
    },
  },
}

const services = {
  async validateCustomSignUp(formData) {
    if (!formData.acknowledgement) {
      return {
        acknowledgement: 'You must agree to the Terms and Conditions',
      };
    }
  },
}

const AuthenticationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  /*
  Check if the user is already logged in when loading the login page.
  It will just skip over the login dialog and go straight to /builder if this is the case.
  */
  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          const restOperation = get({ apiName: 'userapi', path: '/checkSubscription' });
          const { body } = await restOperation.response;
          const str = await body.text();
          sessionStorage.setItem("subscriptionStatus", str);
          navigate('/builder');
        }
      } catch (error) {
        navigate('/login')
        console.log("Please login");
      }
    };

    checkAuthStatus();

     const authListener = Hub.listen('auth', async ({ payload: { event } }) => {
        if (event === 'signedIn') {
            const user = await getCurrentUser();
          if (user) {
            try {
              const restOperation = get({ apiName: 'userapi', path: '/checkSubscription' });
              const { body } = await restOperation.response;
              const str = await body.text();
              sessionStorage.setItem("subscriptionStatus", str);
              navigate('/builder');
            } catch (error) {
              console.log('ERROR CODE: ST01');
            }
          }
        }
      });

    return () => {
      authListener();
    };
  }, [navigate, location.search]);

  return (
    <div className="authentication-page">
      <Authenticator components={components} services={services}/>
    </div>
  );
};

export default AuthenticationPage;
